import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import M2TLogo from '../components/common/M2TLogo';
import FooterLinks from '../components/LandingPage/FooterLinks';
import SeoMeta from '../components/SEO/SeoMeta';
import M2THeroBanner from '../components/LandingPage/M2THeroBanner';

// === ALL FEATURES & PRODUCT ZONES ===
const allFeatures = [
  // Core Features
  "SmartCard Verified Access",
  "Personalized Dashboard",
  "Marketplace Access",
  "Learning Library",
  "Promotion & Marketing Tools",
  "Real-time Alerts & Notifications",
  "Global Multi-role Directory",
  "Community Chat & Groups",
  "Instant Messaging & Support",
  "Premium Business Dashboard",
  "Integrated Wallet & Secure Payments",
  "AI-Powered Insights & Automation",
  "Booking & Appointments",
  "Smart Tool Integrations",
  "Business Deal Desk",
  "Affiliate & Offer Zones",
  "Fundraising & Launch Zone",
  "Recording Vault",
  "Market Expo & Sponsored Events",
  "Verified Recommendations",
  "Multilingual AI Assistant",
  "Multi-language Support",
  "Prepaid Bookings & Payments",
  "Zero Scam Guarantee",
  "Verified Identity System",
  "AI Document & Pitch Generator",
  "Split-Screen Work Mode",
  "Global Access & Free Trial",
  "API Integration",
  "Plugin Ecosystem",
  "Iframe/Embed Services",
  "Work Storage Space",
  "Encrypted File Storage",
  "Anti-Theft Security",
  "Secure Payment Services",
  "Wallet Storage",
  "Team Management",
  "AI Business Assistant",
  "Auto Video Creator",
  "Certifications & Awards",
  // Product Zones
  "Market Office",
  "Market Tools",
  "Marketplace",
  "Traders Community",
  "Professionals Directory",
  "Job Board",
  "Market Face",
  "Academics",
  "Funding Services",
  "Business Deal Desk Zone",
  "Freelancer Zone",
  "Appointment Zone",
  "Expert Room",
  "Launch Zone",
  "Signals Zone",
  "Investment Zone",
  "Media Zone",
  "Market Expo Zone",
];

// === PLAN DATA: featureMatrix contains 1 (✔) or 0 (✗) for each feature
const planTitles = ["Silver", "Gold", "Royal", "Premium"];

const individualFeatureMatrix = [
  // 0 = not included, 1 = included
  // Follows allFeatures order!
  [0, 1, 1, 1], // SmartCard Verified Access
  [1, 1, 1, 1], // Personalized Dashboard
  [1, 1, 1, 1], // Marketplace Access
  [0, 1, 1, 1], // Learning Library
  [0, 1, 1, 1], // Promotion & Marketing Tools
  [0, 1, 1, 1], // Real-time Alerts & Notifications
  [0, 1, 1, 1], // Global Multi-role Directory
  [1, 1, 1, 1], // Community Chat & Groups
  [0, 1, 1, 1], // Instant Messaging & Support
  [0, 0, 1, 1], // Premium Business Dashboard
  [0, 1, 1, 1], // Integrated Wallet & Secure Payments
  [0, 0, 1, 1], // AI-Powered Insights & Automation
  [0, 1, 1, 1], // Booking & Appointments
  [0, 1, 1, 1], // Smart Tool Integrations
  [0, 0, 1, 1], // Business Deal Desk
  [0, 1, 1, 1], // Affiliate & Offer Zones
  [0, 1, 1, 1], // Fundraising & Launch Zone
  [0, 0, 1, 1], // Recording Vault
  [0, 0, 1, 1], // Market Expo & Sponsored Events
  [0, 0, 1, 1], // Verified Recommendations
  [0, 0, 1, 1], // Multilingual AI Assistant
  [0, 0, 1, 1], // Multi-language Support
  [0, 1, 1, 1], // Prepaid Bookings & Payments
  [0, 0, 1, 1], // Zero Scam Guarantee
  [0, 1, 1, 1], // Verified Identity System
  [0, 0, 1, 1], // AI Document & Pitch Generator
  [0, 0, 1, 1], // Split-Screen Work Mode
  [1, 1, 1, 1], // Global Access & Free Trial
  [0, 1, 1, 1], // API Integration
  [0, 1, 1, 1], // Plugin Ecosystem
  [0, 0, 1, 1], // Iframe/Embed Services
  [0, 0, 1, 1], // Work Storage Space
  [0, 0, 1, 1], // Encrypted File Storage
  [0, 0, 1, 1], // Anti-Theft Security
  [0, 0, 1, 1], // Secure Payment Services
  [0, 0, 1, 1], // Wallet Storage
  [0, 0, 1, 1], // Team Management
  [0, 0, 1, 1], // AI Business Assistant
  [0, 0, 1, 1], // Auto Video Creator
  [0, 0, 1, 1], // Certifications & Awards
  // Zones
  [1, 1, 1, 1], // Market Office
  [0, 1, 1, 1], // Market Tools
  [1, 1, 1, 1], // Marketplace
  [1, 1, 1, 1], // Traders Community
  [0, 1, 1, 1], // Professionals Directory
  [0, 1, 1, 1], // Job Board
  [0, 1, 1, 1], // Market Face
  [0, 1, 1, 1], // Academics
  [0, 0, 1, 1], // Funding Services
  [0, 1, 1, 1], // Business Deal Desk Zone
  [0, 1, 1, 1], // Freelancer Zone
  [0, 1, 1, 1], // Appointment Zone
  [0, 0, 1, 1], // Expert Room
  [0, 0, 1, 1], // Launch Zone
  [0, 0, 1, 1], // Signals Zone
  [0, 0, 1, 1], // Investment Zone
  [0, 0, 1, 1], // Media Zone
  [0, 0, 1, 1], // Market Expo Zone
];

// --- Businesses ---
const businessFeatureMatrix = [
  [0, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1],
  [0, 1, 1, 1], [0, 0, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 0, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1],
  [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 0, 1, 1], [1, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1],
  [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [1, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1],
  // Zones
  [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [0, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]
];

// --- Institutions ---
const institutionFeatureMatrix = [
  [0, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [0, 1, 1, 1],
  [1, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1],
  [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1],
  [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1],
  // Zones
  [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]
];

const plansData = {
  individual: [
    {
      name: "Silver",
      price: "Free",
      features: ["Personalized Dashboard", "Marketplace Access", "Traders Community", "Market Office", "Join Waitlist"],
      cta: "Get Started",
      badge: null,
    },
    {
      name: "Gold",
      price: "$19/mo",
      features: ["All Silver features", "Learning Library", "Professional Directory", "Wallet & Payments", "Booking & Appointments"],
      cta: "Upgrade",
      badge: null,
    },
    {
      name: "Royal",
      price: "$49/mo",
      features: ["All Gold features", "Signals Zone & Alerts", "AI & Automation", "Verified Badge", "Business Deal Desk"],
      cta: "Most Popular",
      badge: "Most Popular",
    },
    {
      name: "Premium",
      price: "$99/mo",
      features: ["All Features Included", "SmartCard Access", "Media & Expo Zones", "AI Assistant", "VIP Concierge Support"],
      cta: "Go Premium",
      badge: null,
    }
  ],
  business: [
    {
      name: "Silver",
      price: "Free",
      features: ["Personalized Dashboard", "Marketplace Access", "Team Directory", "Market Office", "Join Waitlist"],
      cta: "Get Started",
      badge: null,
    },
    {
      name: "Gold",
      price: "$129/mo",
      features: ["All Silver features", "Learning Library", "Wallet & Payments", "Up to 5 Team Members", "Business Deal Desk"],
      cta: "Upgrade",
      badge: null,
    },
    {
      name: "Royal",
      price: "$499/mo",
      features: ["All Gold features", "API Integrations", "Signals Zone", "Verified Business Badge", "20 Team Members"],
      cta: "Most Popular",
      badge: "Most Popular",
    },
    {
      name: "Premium",
      price: "$999/mo",
      features: ["All Features Included", "SmartCard & Concierge", "Unlimited Members", "AI Assistant", "Custom Integrations"],
      cta: "Go Premium",
      badge: null,
    }
  ],
  institution: [
    {
      name: "Silver",
      price: "Free",
      features: ["Personalized Dashboard", "Marketplace Access", "Institution Directory", "Market Office", "Join Waitlist"],
      cta: "Get Started",
      badge: null,
    },
    {
      name: "Gold",
      price: "$1,099/mo",
      features: ["All Silver features", "Learning Library", "Wallet & Payments", "Up to 50 Members", "Funding & Launch Zone"],
      cta: "Upgrade",
      badge: null,
    },
    {
      name: "Royal",
      price: "$1,999/mo",
      features: ["All Gold features", "API Integrations", "Signals Zone", "Verified Institution Badge", "200 Members"],
      cta: "Best Value",
      badge: "Best Value",
    },
    {
      name: "Premium",
      price: "$2,999/mo",
      features: ["All Features Included", "SmartCard & Concierge", "Unlimited Members", "AI Assistant", "Custom Integrations"],
      cta: "Go Premium",
      badge: null,
    }
  ]
};

const featureMatrixMap = {
  individual: individualFeatureMatrix,
  business: businessFeatureMatrix,
  institution: institutionFeatureMatrix
};

export default function M2TPricingPage() {
  const [planType, setPlanType] = useState("individual");
  const plans = plansData[planType];
  const featureMatrix = featureMatrixMap[planType];
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white ">

      <SeoMeta
        title="M2T Pricing – Compare All Plans, Features & AI Product Zones"
        description="See Million2Trillion's transparent pricing for Individuals, Businesses, and Institutions. Compare every feature and product zone—AI, SmartCard, Signals, Verified Directory, Marketplace, Funding, Expo, Media & more. Start free or go premium!"
        keywords="M2T pricing, Million2Trillion plans, financial SaaS pricing, market network subscription, AI product features, verified marketplace, smartcard access, signals zone, business funding, compare plans, institutions pricing, enterprise trading platform"
        url="https://million2trillion.com/pricing"
        canonical="https://million2trillion.com/pricing"
      />



      {/* Header */}
      <header className="flex items-center gap-3 px-6 py-5 bg-white shadow-md sticky top-0 z-30">
        <div
          className="flex items-center gap-2 cursor-pointer"
          onClick={() => navigate('/')}
          aria-label="Go to homepage"
        >
          <M2TLogo className="w-12 h-12 sm:w-14 sm:h-14" />
          <div className="hidden sm:block leading-tight text-left">
            <div className="font-semibold text-lg md:text-2xl text-black">Million2Trillion</div>
            <div className="text-[9px] md:text-xs tracking-wide text-gray-500">
              AI-Powered <span className="text-black/80">Market Network</span>
            </div>
          </div>
        </div>
      </header>

      {/* Headline */}
      <div className="text-center mt-16 mb-3">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-blue-900 mb-2">Flexible Pricing for Every Market Role</h1>
        <p className="text-lg text-blue-700/90 font-medium mb-5">
          All your features, product zones, and AI tools—transparent pricing for Individuals, Businesses, and Institutions.
        </p>
      </div>

      {/* Plan Type Toggle */}
      <div className="w-full px-12 sm:px-0 border"> {/* Responsive horizontal padding */}
        <div className="flex justify-center gap-3 my-4">
          <button
            className={`px-5 py-2 rounded-lg font-semibold sm:font-bold border transition ${planType === "individual" ? "bg-blue-800 text-white border-blue-800" : "bg-white text-blue-900 border-blue-300"}`}
            onClick={() => setPlanType("individual")}
          >
            Individuals
          </button>
          <button
            className={`px-5 py-2 rounded-lg font-semibold sm:font-bold border transition ${planType === "business" ? "bg-blue-800 text-white border-blue-800" : "bg-white text-blue-900 border-blue-300"}`}
            onClick={() => setPlanType("business")}
          >
            Businesses
          </button>
          <button
            className={`px-5 py-2 rounded-lg font-semibold sm:font-bold border transition ${planType === "institution" ? "bg-blue-800 text-white border-blue-800" : "bg-white text-blue-900 border-blue-300"}`}
            onClick={() => setPlanType("institution")}
          >
            Institutions
          </button>
        </div>
      </div>


      {/* Pricing Cards */}
      <div className="w-full overflow-x-auto py-8">
        <div className="flex gap-6 min-w-[950px] max-w-6xl mx-auto px-2 sm:px-0">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`relative flex flex-col items-center bg-white rounded-2xl border border-blue-200 shadow-md px-8 py-8 min-w-[210px] max-w-[260px] w-full ${plan.badge ? "ring-2 ring-purple-400 z-10" : ""}`}
            >
              {plan.badge && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-purple-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-md">
                  {plan.badge}
                </div>
              )}
              <div className="text-xl font-bold mb-1 text-blue-900">{plan.name}</div>
              <div className="text-3xl font-extrabold mb-2 text-blue-700">{plan.price}</div>
              <ul className="mb-4 text-gray-700 text-sm space-y-1 min-h-[92px]">
                {plan.features.map((f, i) => (
                  <li key={i} className="flex items-center gap-2">
                    <span className="text-green-500 text-lg">✔</span> {f}
                  </li>
                ))}
              </ul>
              <button className="bg-gradient-to-r from-purple-500 to-blue-600 hover:from-purple-700 hover:to-blue-800 text-white px-7 py-2 rounded-lg font-semibold mt-auto transition">
                {plan.cta}
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Feature Comparison Table */}
      <div className="overflow-x-auto mt-10">
        <table className="min-w-[600px] w-full max-w-6xl mx-auto bg-white rounded-xl shadow-md border border-blue-200 text-[11px] sm:text-sm">

          <thead>
            <tr>
              <th className="py-3 px-4 text-left text-blue-900 text-base font-bold">Features & Product Zones</th>
              {planTitles.map((t, idx) => (
                <th key={t} className="py-3 px-4 text-center text-blue-700 font-bold">{t}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {allFeatures.map((row, i) => (
              <tr key={row} className={i % 2 === 0 ? "bg-blue-50/30" : ""}>
                <td className="py-2 px-4 text-gray-700 font-medium">{row}</td>
                {featureMatrix[i].map((v, j) =>
                  <td key={j} className="py-2 px-4 text-center font-bold" style={{ color: v ? "#22c55e" : "#e11d48", fontSize: "1.2em" }}>
                    {v ? "✔" : "✗"}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer Callout */}
      <div className="bg-blue-900/90 rounded-xl p-6 mt-32 text-center text-white text-xl font-bold shadow-lg max-w-2xl mx-auto mb-52 ">
        No payment required for the first 3 months.<br />
        <span className="text-base font-normal">Enjoy full access, risk-free. Cancel anytime. No card needed for signup.</span>
      </div>
      <M2THeroBanner />
      <FooterLinks />
    </div>

  );
}
